import { ImageUploaderProps } from "components/common/Uploader/ImageUploader/ImageUploader";
import {toTitleCase} from "@/utils/reCase";

export const getToolName = (pathname: string) => pathname.split("/")[1];

export const getHtmlFileInputId = (pathname: string) => {

    switch (getToolName(pathname)) {
        case "image-converter":
            return "image-converter-file-input";
        default:
            const dynamicToolName =  pathname.split("/").pop();
            return `${dynamicToolName}-file-input`;
    }
};

export const getAnalytics = (pathname: string): ImageUploaderProps["analytics"] => {

    switch (getToolName(pathname)) {
        case "image-converter":
            return {
                pageKey: "image_converter",
                pageTitle: "Image Converter",
            };
        default:
            const dynamicToolName =  pathname.split("/").pop();
            return {
                pageKey: dynamicToolName ?? "",
                pageTitle: toTitleCase(pathname.replaceAll("/", " ")),
            }
    }
};

